var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_1232",
    "data-name": "Gruppe 1232",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 60,
    viewBox: "0 0 135 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_38",
    "data-name": "Gruppe 38",
    transform: "translate(66.969 18.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_76",
    "data-name": "Pfad 76",
    d: "M114.524,191.263a8.781,8.781,0,1,0,8.781,8.66A8.628,8.628,0,0,0,114.524,191.263Zm0,14.943a5.99,5.99,0,0,1-5.8-6.283,5.8,5.8,0,1,1,11.595,0A5.99,5.99,0,0,1,114.524,206.206Z",
    transform: "translate(-105.743 -191.263)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_77",
    "data-name": "Pfad 77",
    d: "M144.189,198.818c-1.741-.72-3.244-1.342-3.244-2.728,0-1.245,1.168-2.184,2.717-2.184a6.3,6.3,0,0,1,3.772,1.436l1.244-2.334a7.4,7.4,0,0,0-4.991-1.745c-3.223,0-5.652,2.1-5.652,4.876,0,2.919,2.551,4.02,4.8,4.99,1.783.769,3.323,1.432,3.323,2.846,0,1.525-1.316,2.207-2.62,2.207a6.881,6.881,0,0,1-4.275-1.758l-1.559,2.16a8.372,8.372,0,0,0,5.786,2.242c3.27,0,5.555-2.025,5.555-4.924C149.047,200.827,146.467,199.76,144.189,198.818Z",
    transform: "translate(-117.023 -191.263)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_78",
    "data-name": "Pfad 78",
    d: "M171.311,191.712H160.3v2.377h4.148v14.6h2.693v-14.6h4.172Z",
    transform: "translate(-124.996 -191.421)",
    fill: "#191919"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_39",
    "data-name": "Gruppe 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_79",
    "data-name": "Pfad 79",
    d: "M49.28,170.831a27.513,27.513,0,1,0-.076,38.814c4.981-4.982,13.67-11.86,13.67-19.445C62.874,182.653,54.216,175.806,49.28,170.831ZM47.9,205.812a21.941,21.941,0,0,1-15.555,6.453c-.681,0-1.355-.036-2.021-.1-.339-.031-.676-.071-1.01-.117-.665.092-1.338.157-2.021.188-.335.015-.672.025-1.011.025a22.011,22.011,0,0,1,0-44.021c.338,0,.674.011,1.008.026.683.031,1.357.1,2.022.188q.5-.07,1.01-.117c.667-.061,1.34-.1,2.022-.1a21.94,21.94,0,0,1,15.616,6.516c3.949,3.981,10.876,9.458,10.876,15.5C58.832,196.323,51.88,201.826,47.9,205.812Z",
    transform: "translate(-2.25 -162.686)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80",
    "data-name": "Pfad 80",
    d: "M62.714,177.791A21.94,21.94,0,0,0,47.1,171.275a16.087,16.087,0,0,0-3.032.214c5.294.484,11.063,2.729,14.607,6.3,3.949,3.981,10.875,9.458,10.875,15.5,0,6.068-6.952,11.571-10.936,15.556-4.059,4.06-9.282,5.758-14.545,6.24a18.7,18.7,0,0,0,3.031.214,21.941,21.941,0,0,0,15.555-6.454c3.985-3.986,10.936-9.489,10.936-15.556C73.589,187.249,66.663,181.771,62.714,177.791Z",
    transform: "translate(-17.007 -165.717)",
    fill: "#8c195f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_81",
    "data-name": "Pfad 81",
    d: "M44.066,171.606a21.963,21.963,0,0,1,12.586,6.3c3.949,3.981,10.875,9.458,10.875,15.5,0,6.068-6.951,11.571-10.936,15.556a21.966,21.966,0,0,1-12.523,6.24h0c5.2-.461,10.57-2.215,14.545-6.24s10.936-9.489,10.936-15.556c0-6.037-6.926-11.515-10.875-15.5-3.545-3.572-9.314-5.817-14.607-6.3",
    transform: "translate(-17.007 -165.833)",
    fill: "#d72864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_82",
    "data-name": "Pfad 82",
    d: "M7.395,193.286c0-11.8,9.484-21.471,23.016-21.8a21.216,21.216,0,0,0-3.03-.214,22.011,22.011,0,0,0,0,44.021,13.131,13.131,0,0,0,3.032-.214C18.786,215.4,7.395,205.083,7.395,193.286Z",
    transform: "translate(-3.352 -165.717)",
    fill: "#8c195f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_83",
    "data-name": "Pfad 83",
    d: "M12.537,193.4a21.984,21.984,0,0,1,18.976-21.8h0c-13.529.326-23.016,10-23.016,21.8s11.375,22.116,23.018,21.8h0A22.04,22.04,0,0,1,12.537,193.4Z",
    transform: "translate(-4.455 -165.833)",
    fill: "#d72864"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40",
    "data-name": "Gruppe 40",
    transform: "translate(68.052 42.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_84",
    "data-name": "Pfad 84",
    d: "M107.412,232.063c0-1.958,1.085-3.39,3.044-3.39,1.941,0,2.872,1.433,2.872,3.255,0,2.14-1.04,3.535-3,3.535C108.342,235.463,107.412,234.031,107.412,232.063Zm5.287-.045c0-1.813-.911-2.81-2.261-2.81-1.367,0-2.388,1.006-2.388,2.855s.948,2.865,2.315,2.865S112.7,233.967,112.7,232.018Z",
    transform: "translate(-107.412 -228.51)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_85",
    "data-name": "Pfad 85",
    d: "M121.414,233.095l-.6.072c-.109-.608-.283-.952-1.048-.952-.812,0-1,.354-1,.753,0,.544.409.67,1.112.843.857.208,1.622.39,1.622,1.4,0,.8-.6,1.323-1.723,1.323-1.021,0-1.668-.39-1.8-1.4l.583-.1a1.081,1.081,0,0,0,1.249.979c.611,0,1.076-.182,1.076-.771,0-.544-.383-.653-1.057-.825-.775-.2-1.687-.318-1.687-1.378,0-.9.775-1.332,1.649-1.332A1.423,1.423,0,0,1,121.414,233.095Z",
    transform: "translate(-111.091 -229.578)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_86",
    "data-name": "Pfad 86",
    d: "M127.308,235.514a2.166,2.166,0,0,1-1.057.29,1.079,1.079,0,0,1-1.24-1.242V231.57h-.729v-.507h.729v-1.333l.611-.091v1.423h1.3v.507h-1.3v2.91c0,.526.109.825.72.825a1.84,1.84,0,0,0,.83-.236Z",
    transform: "translate(-113.292 -228.851)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_87",
    "data-name": "Pfad 87",
    d: "M133.243,233.095l-.6.072c-.109-.608-.282-.952-1.048-.952-.811,0-1,.354-1,.753,0,.544.41.67,1.112.843.857.208,1.622.39,1.622,1.4,0,.8-.6,1.323-1.723,1.323-1.021,0-1.668-.39-1.8-1.4l.583-.1a1.081,1.081,0,0,0,1.249.979c.611,0,1.076-.182,1.076-.771,0-.544-.383-.653-1.057-.825-.775-.2-1.687-.318-1.687-1.378,0-.9.775-1.332,1.649-1.332A1.423,1.423,0,0,1,133.243,233.095Z",
    transform: "translate(-115.214 -229.578)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_88",
    "data-name": "Pfad 88",
    d: "M136.713,234.137c0-1.622.821-2.438,2.206-2.438a1.557,1.557,0,0,1,1.7,1.55l-.61.082c-.082-.744-.429-1.106-1.14-1.106-.729,0-1.513.4-1.513,1.831,0,1.523.748,1.93,1.5,1.93a1.106,1.106,0,0,0,1.231-1.024l.575.118a1.7,1.7,0,0,1-1.841,1.45C137.278,236.531,136.713,235.533,136.713,234.137Z",
    transform: "translate(-117.625 -229.578)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_89",
    "data-name": "Pfad 89",
    d: "M148.5,235.265h-.61V232.2c0-.707-.246-1.125-.967-1.125a2.657,2.657,0,0,0-1.549.662v3.526h-.61v-6.844h.61V231.2a2.89,2.89,0,0,1,1.713-.662c.993,0,1.413.553,1.413,1.6Z",
    transform: "translate(-120.431 -228.421)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_90",
    "data-name": "Pfad 90",
    d: "M153.258,236.471l-1.5-4.632h.629l1.24,4.016,1.1-4.016h.666l1.085,4,1.231-4h.584l-1.468,4.632h-.739l-1.048-3.952-1.057,3.952Z",
    transform: "translate(-122.871 -229.627)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_91",
    "data-name": "Pfad 91",
    d: "M162.753,234.11a2.1,2.1,0,0,1,2.16-2.411c1.276,0,1.8.861,1.8,1.967-.008.182-.018.372-.045.562H163.4c.037,1.387.684,1.758,1.5,1.758a1.033,1.033,0,0,0,1.176-.879l.575.109a1.677,1.677,0,0,1-1.8,1.314C163.227,236.531,162.753,235.388,162.753,234.11Zm3.318-.371c.018-.952-.347-1.514-1.212-1.514a1.412,1.412,0,0,0-1.449,1.514Z",
    transform: "translate(-126.701 -229.578)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_92",
    "data-name": "Pfad 92",
    d: "M171.168,229.578a.481.481,0,1,1,.492-.481A.443.443,0,0,1,171.168,229.578Zm.292,5.756h-.611V230.7h.611Z",
    transform: "translate(-129.463 -228.49)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_93",
    "data-name": "Pfad 93",
    d: "M174.286,235.964h2.908v.507h-3.619v-.426l2.808-3.7h-2.762v-.507H177.1v.436Z",
    transform: "translate(-130.473 -229.627)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_94",
    "data-name": "Pfad 94",
    d: "M180.126,234.11a2.1,2.1,0,0,1,2.16-2.411c1.276,0,1.8.861,1.8,1.967-.008.182-.018.372-.045.562h-3.264c.037,1.387.684,1.758,1.5,1.758a1.033,1.033,0,0,0,1.176-.879l.575.109a1.677,1.677,0,0,1-1.8,1.314C180.6,236.531,180.126,235.388,180.126,234.11Zm3.318-.371c.018-.952-.347-1.514-1.212-1.514a1.412,1.412,0,0,0-1.449,1.514Z",
    transform: "translate(-132.756 -229.578)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_95",
    "data-name": "Pfad 95",
    d: "M190.6,232.334a2.128,2.128,0,0,0-1.677.535v3.554h-.611v-4.632h.5l.055.644a1.728,1.728,0,0,1,1.586-.735h.146Z",
    transform: "translate(-135.611 -229.577)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_96",
    "data-name": "Pfad 96",
    d: "M108.722,251.651h-.611v-6.563h3.728v.525h-3.117v2.557h2.889v.535h-2.889Z",
    transform: "translate(-107.656 -234.302)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_97",
    "data-name": "Pfad 97",
    d: "M118.23,251.911c0,.254.046.363.282.363a.978.978,0,0,0,.283-.054l.037.39a1.17,1.17,0,0,1-.556.126.549.549,0,0,1-.6-.58,2.121,2.121,0,0,1-1.55.607,1.2,1.2,0,0,1-1.376-1.25c0-1.314,1.2-1.559,2.261-1.559.264,0,.428.008.61.018v-.463c0-.707-.2-1.088-1.011-1.088-.739,0-.994.291-1.094.834l-.574-.1c.146-.861.711-1.224,1.7-1.224,1.112,0,1.586.435,1.586,1.586Zm-.6-1.45a4.542,4.542,0,0,0-.574-.027c-.638,0-1.668.045-1.668.988,0,.453.164.852.883.852a1.909,1.909,0,0,0,1.358-.635Z",
    transform: "translate(-109.969 -235.305)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_98",
    "data-name": "Pfad 98",
    d: "M122.083,250.37c0-1.623.821-2.438,2.206-2.438a1.557,1.557,0,0,1,1.7,1.55l-.61.082c-.081-.743-.428-1.106-1.139-1.106-.729,0-1.513.4-1.513,1.831,0,1.523.748,1.931,1.5,1.931a1.106,1.106,0,0,0,1.231-1.024l.575.117a1.7,1.7,0,0,1-1.841,1.45C122.648,252.763,122.083,251.766,122.083,250.37Z",
    transform: "translate(-112.526 -235.305)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_99",
    "data-name": "Pfad 99",
    d: "M133.871,251.5h-.61v-3.064c0-.707-.246-1.124-.967-1.124a2.661,2.661,0,0,0-1.549.662V251.5h-.61v-6.844h.61v2.783a2.894,2.894,0,0,1,1.713-.661c.994,0,1.413.553,1.413,1.6Z",
    transform: "translate(-115.332 -234.149)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_100",
    "data-name": "Pfad 100",
    d: "M142.074,251.5h-.61v-3.064c0-.707-.246-1.124-.967-1.124a2.661,2.661,0,0,0-1.549.662V251.5h-.61v-6.844h.61v2.783a2.894,2.894,0,0,1,1.713-.661c.994,0,1.413.553,1.413,1.6Z",
    transform: "translate(-118.191 -234.149)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_101",
    "data-name": "Pfad 101",
    d: "M146.051,250.361a2.126,2.126,0,0,1,2.215-2.429c1.422,0,2.014.934,2.014,2.312,0,1.523-.611,2.519-2.132,2.519C146.571,252.763,146.051,251.721,146.051,250.361Zm3.591-.063c0-1.378-.519-1.841-1.412-1.841-.921,0-1.549.562-1.549,1.868s.5,1.922,1.513,1.922C149.086,252.247,149.642,251.7,149.642,250.3Z",
    transform: "translate(-120.88 -235.305)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_102",
    "data-name": "Pfad 102",
    d: "M154.143,250.37c0-1.623.82-2.438,2.205-2.438a1.558,1.558,0,0,1,1.7,1.55l-.61.082c-.082-.743-.429-1.106-1.14-1.106-.729,0-1.513.4-1.513,1.831,0,1.523.748,1.931,1.5,1.931a1.106,1.106,0,0,0,1.231-1.024l.574.117a1.7,1.7,0,0,1-1.841,1.45C154.708,252.763,154.143,251.766,154.143,250.37Z",
    transform: "translate(-123.7 -235.305)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_103",
    "data-name": "Pfad 103",
    d: "M165.929,251.5h-.611v-3.064c0-.707-.246-1.124-.966-1.124a2.657,2.657,0,0,0-1.549.662V251.5h-.611v-6.844h.611v2.783a2.892,2.892,0,0,1,1.713-.661c.993,0,1.413.553,1.413,1.6Z",
    transform: "translate(-126.506 -234.149)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_104",
    "data-name": "Pfad 104",
    d: "M173.226,249.328l-.6.072c-.109-.607-.283-.952-1.048-.952-.811,0-1,.353-1,.753,0,.544.41.671,1.112.843.857.209,1.622.39,1.622,1.4,0,.8-.6,1.323-1.722,1.323-1.021,0-1.668-.389-1.805-1.4l.584-.1a1.08,1.08,0,0,0,1.249.979c.61,0,1.076-.181,1.076-.77,0-.544-.383-.653-1.057-.825-.775-.2-1.687-.317-1.687-1.378,0-.9.775-1.332,1.649-1.332A1.422,1.422,0,0,1,173.226,249.328Z",
    transform: "translate(-129.15 -235.305)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_105",
    "data-name": "Pfad 105",
    d: "M176.7,250.37c0-1.623.821-2.438,2.206-2.438a1.558,1.558,0,0,1,1.7,1.55l-.61.082c-.082-.743-.429-1.106-1.14-1.106-.729,0-1.513.4-1.513,1.831,0,1.523.747,1.931,1.5,1.931a1.105,1.105,0,0,0,1.23-1.024l.575.117a1.7,1.7,0,0,1-1.841,1.45C177.26,252.763,176.7,251.766,176.7,250.37Z",
    transform: "translate(-131.561 -235.305)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_106",
    "data-name": "Pfad 106",
    d: "M188.483,251.5h-.61v-3.064c0-.707-.246-1.124-.966-1.124a2.657,2.657,0,0,0-1.549.662V251.5h-.611v-6.844h.611v2.783a2.89,2.89,0,0,1,1.713-.661c.994,0,1.413.553,1.413,1.6Z",
    transform: "translate(-134.367 -234.149)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_107",
    "data-name": "Pfad 107",
    d: "M192.935,248.072h.61v3.064c0,.707.219,1.123.939,1.123a2.659,2.659,0,0,0,1.55-.661v-3.526h.611V252.7h-.538l-.036-.58a3.009,3.009,0,0,1-1.75.671c-.994,0-1.386-.553-1.386-1.6Z",
    transform: "translate(-137.221 -235.355)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_108",
    "data-name": "Pfad 108",
    d: "M201.764,251.5h-.611v-6.844h.611Z",
    transform: "translate(-140.085 -234.149)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_109",
    "data-name": "Pfad 109",
    d: "M204.106,250.343a2.1,2.1,0,0,1,2.161-2.411c1.276,0,1.8.861,1.8,1.967-.009.181-.018.371-.046.562h-3.263c.036,1.387.683,1.759,1.5,1.759a1.033,1.033,0,0,0,1.175-.88l.575.109a1.676,1.676,0,0,1-1.8,1.314C204.58,252.763,204.106,251.621,204.106,250.343Zm3.318-.371c.019-.953-.346-1.514-1.212-1.514a1.413,1.413,0,0,0-1.449,1.514Z",
    transform: "translate(-141.115 -235.305)",
    fill: "#191919"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOst);
export default __webpack_public_path__ + "static/media/logo_ost.3a64c5a69f12af58a503fc9a023b071d.svg";
export { ForwardRef as ReactComponent };